export const config = {
  version: "1.9.113",
  api: {
    //url: 'http://vm-smarter.brazilsouth.cloudapp.azure.com:30001/', // producción ARGEN
    //url: 'http://digital-minds.com.ar:30001/', // testing  DIGITAL
    url: "http://localhost:35784/", // DEBBUG
    ambientes: [
      { id: "Development", url: "http://localhost:35784/" },
      { id: "Testing - Digital", url: "http://digital-minds.com.ar:30001/" },
      {
        id: "Testing - Argen",
        url: "http://smarter.argenpesos.com.ar:30002/",
      },
      {
        id: "Testing - Argen (https)",
        url: "https://test.smarter.argenpesos.com.ar:30002/",
      },
      {
        id: "Produccion api 2 (https)",
        url: "https://smarter.argenpesos.com.ar:30011/",
      },
      {
        id: "Reporting (https)",
        url: "https://smarter.argenpesos.com.ar:30012/",
      },
      {
        id: "Producción (https)",
        url: "https://smarter.argenpesos.com.ar:30010/",
      },
    ],
    path: {
      default: "",
      files: "storage/",
    },
  },
};
